import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c6c9ca0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6c9ca0')) {
      api.createRecord('4c6c9ca0', component.options)
    } else {
      api.reload('4c6c9ca0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c6c9ca0&", function () {
      api.rerender('4c6c9ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pain008/components_Traitement/index.vue"
export default component.exports